import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getLoggedInUser } from "../../helpers/authUtils";
import ROUTES from "../../config/routes";
import swal from "sweetalert";
import DEATH_API from "../../apis/death.api";
import { Redirect, Link } from "react-router-dom";

const initialState = {
  loading: false,
  // user: getLoggedInUser(),
  loginUserData: getLoggedInUser(),
  UserData: {},
  userId: "",
  userOtp: "",
  savedOtp: "",
  error: "",
  aNotes: false,
  eNotes: false,
  stepsFields: [],
  Step1: [],
  Step2: [],
  Step3: [],
  Step4: [],
  Step5: [],
  CompletedSteps: [],
  selectedCollection: "",
  monthlyPaymet: "",
  activated: false,
  clientOtpData: {},
  activeStep: 0,
  activeBudgetTab: 0,
  budgetReportData: null,
  userOnline: false,
};

// A slice for login with our 3 reducers
const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    postLoginLoading: (state) => {
      state.loading = true;
    },
    postClientOtpData: (state, { payload }) => {
      state.clientOtpData = payload;
      state.loading = false;
    },
    postLoginSuccess: (state, { payload }) => {
      state.loginUserData = payload;
      state.loading = false;
    },
    postUserData: (state, { payload }) => {
      state.UserData = payload;
      state.loading = false;
    },

    postLoginId: (state, { payload }) => {
      state.userId = payload;
      state.loading = false;
    },
    setActivated: (state, { payload }) => {
      state.activated = payload;
      state.loading = false;
    },
    setUserOnline: (state, { payload }) => {
      state.userOnline = payload;
    },
    setActiveStep: (state, { payload }) => {
      state.activeStep = payload;
      state.loading = false;
    },
    setActiveBudgetTab: (state, { payload }) => {
      state.activeBudgetTab = payload;
      state.loading = false;
    },
    postUserOtp: (state, { payload }) => {
      state.userOtp = payload;
      state.loading = false;
    },
    postselectedCollection: (state, { payload }) => {
      state.selectedCollection = payload;
      state.loading = false;
    },
    postSavedOtp: (state, { payload }) => {
      state.savedOtp = payload;
      state.loading = false;
    },
    postStepsFields: (state, { payload }) => {
      state.stepsFields = payload;
      state.loading = false;
    },
    postStep1: (state, { payload }) => {
      state.Step1 = payload;
      state.loading = false;
    },
    postStep2: (state, { payload }) => {
      state.Step2 = payload;
      state.loading = false;
    },
    postStep3: (state, { payload }) => {
      state.Step3 = payload;
      state.loading = false;
    },
    postStep4: (state, { payload }) => {
      state.Step4 = payload;
      state.loading = false;
    },
    postmonthlyPaymet: (state, { payload }) => {
      state.monthlyPaymet = payload;
      state.loading = false;
    },
    postStep5: (state, { payload }) => {
      state.Step5 = payload;
      state.loading = false;
    },
    postCompletedSteps: (state, { payload }) => {
      state.CompletedSteps = payload;
      state.loading = false;
    },
    postaNotes: (state, { payload }) => {
      state.aNotes = payload;
      state.loading = false;
    },
    posteNotes: (state, { payload }) => {
      state.eNotes = payload;
      state.loading = false;
    },
    postLoginFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    postBudgetReportData: (state, { payload }) => {
      state.budgetReportData = payload;
      state.loading = false;
    },
  },
});

// Three actions generated from the slice
export const {
  postLoginLoading,
  postUserData,
  postLoginSuccess,
  postLoginFailure,
  postLoginId,
  postUserOtp,
  postSavedOtp,
  posteNotes,
  postaNotes,
  postStepsFields,
  postStep1,
  postStep2,
  postStep3,
  postStep4,
  postStep5,
  postCompletedSteps,
  postselectedCollection,
  postmonthlyPaymet,
  setActivated,
  postClientOtpData,
  setActiveStep,
  setActiveBudgetTab,
  postBudgetReportData,
  setUserOnline,
} = loginSlice.actions;

// A selector
// export const loginSelector = state => state.login

// The reducer
export default loginSlice.reducer;

// Asynchronous thunk action
export function postLoginUser(userData, config, history, location, setLoading) {
  const getClientList = async () => {
    // setLoading(true)
    console.log("location in login", location);
    let responseData = await DEATH_API.fetchClientList();
    console.log("responseData", responseData.data[0].users);
    const newData = responseData.data[0].users;
    // console.log("newData",newData)
    newData.map((item, index) => (item["Status"] = false));
    console.log("newData", newData);

    localStorage.setItem("delegateUsers", JSON.stringify(newData));
    setLoading(false);
    swal("Success", "Login Success", "success");
    history.push("/delgateAccess");
  };
  return async (dispatch) => {
    console.log(
      "host location",
      `${window.location.protocol}//${window.location.hostname}`
    );
    if (userData && !Object.isFrozen(userData)) {
    userData.source = `${window.location.protocol}//${window.location.hostname}`;
    }
    dispatch(postLoginLoading());
    dispatch(postUserData(userData));
    if (userData && userData.username && userData.password) {
      try {
        setLoading(true);
        const res = await axios.post(
          `${ROUTES.BASE_URL}/auth-service/auth/signinClient`,
          userData,
          config
        );
        dispatch(postLoginId(res.data.id));
        setLoading(false);
        if (userData.hasOwnProperty("phone")) {
          if (location.state && location.state.from) {
            history.push({
              pathname: "/otpvalidation",
              state: { from: location.state.from },
              PathExact: location.PathExact,
            });
          } else {
            history.push("/otpvalidation");
          }
        }

        if (res.status === 200 && res.data.id) {
          dispatch(postClientOtpData(userData));
          if (location.state && location.state.from) {
            history.push({
              pathname: "/otpvalidation",
              state: { from: location.state.from },
              PathExact: location.PathExact,
            });
          } else {
            history.push("/otpvalidation");
          }
        }
      } catch (error) {
        setLoading(false);
        if(error.response && error.response.data && error.response.data.message){
          swal("Oops!", error.response.data.message, "error");
          console.log("error", error);
          dispatch(postLoginFailure(error.response.data.message));
        }
      }
    } else {
      swal("Oops!",(userData && userData.username && "Please enter a valid Password") || (userData && userData.password  && "Please enter a valid Username") || "Please enter a valid Username and Password", "error");

    }
  };
}
